import { useState } from "react";
import { api, notifyError } from "@/lib/api";
import { Calculator } from "@phosphor-icons/react";
import { Field, SelectField, ResultPanel } from "./shared";

const TILES = [
  { key: "enhanced_deduction", label: "Enhanced deduction", money: true },
  { key: "deduction_ct_saving", label: "Deduction CT saving", money: true },
  { key: "rd_tax_credit", label: "R&D tax credit", money: true, color: "#00A86B" },
  { key: "total_benefit", label: "Total benefit", money: true, color: "#00A86B" },
  { key: "net_ct_payable", label: "Net CT payable", money: true },
  { key: "effective_rd_cost", label: "Effective R&D cost", money: true },
];

const STATUS = [
  { value: "profitable", label: "Profitable" },
  { value: "loss_making", label: "Loss-making" },
  { value: "startup", label: "Startup" },
];
const CLAIM = [
  { value: "standard", label: "Standard" },
  { value: "key_employee", label: "Key employee" },
];

export default function RDCalc({ onSaved }) {
  const [f, setF] = useState({ qualifying_expenditure: "", corporation_tax_liability: "", tax_year: new Date().getFullYear(), company_status: "profitable", claim_type: "standard" });
  const [calc, setCalc] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const run = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/tax/calculate/rd", {
        qualifying_expenditure: Number(f.qualifying_expenditure),
        corporation_tax_liability: Number(f.corporation_tax_liability),
        tax_year: Number(f.tax_year),
        company_status: f.company_status,
        claim_type: f.claim_type,
      });
      setCalc(r.data);
      onSaved && onSaved();
    } catch (err) { notifyError(err); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <form onSubmit={run} className="glass rounded-2xl p-6 space-y-4">
        <div>
          <div className="eyebrow mb-1">Research & Development tax credit</div>
          <p className="text-white/55 text-sm">Corporation-tax credit plus enhanced deduction on qualifying R&D spend.</p>
        </div>
        <Field label="Qualifying R&D expenditure (€)" type="number" step="0.01" required data-testid="rd-expenditure" value={f.qualifying_expenditure} onChange={(e) => set("qualifying_expenditure", e.target.value)} />
        <Field label="Corporation-tax liability before credit (€)" type="number" step="0.01" required data-testid="rd-ct-liability" value={f.corporation_tax_liability} onChange={(e) => set("corporation_tax_liability", e.target.value)} />
        <div className="grid grid-cols-3 gap-4">
          <Field label="Tax year" type="number" data-testid="rd-year" value={f.tax_year} onChange={(e) => set("tax_year", e.target.value)} />
          <SelectField label="Company status" options={STATUS} data-testid="rd-status" value={f.company_status} onChange={(e) => set("company_status", e.target.value)} />
          <SelectField label="Claim type" options={CLAIM} data-testid="rd-claim-type" value={f.claim_type} onChange={(e) => set("claim_type", e.target.value)} />
        </div>
        <button type="submit" disabled={busy} className="btn-gold w-full justify-center" data-testid="rd-calculate"><Calculator size={16} weight="fill" /> {busy ? "Calculating…" : "Calculate R&D benefit"}</button>
      </form>
      {calc ? <ResultPanel calc={calc} tiles={TILES} /> : (
        <div className="glass rounded-2xl p-6 flex items-center justify-center text-white/40 text-sm text-center">Enter your R&D spend to estimate credit and deduction benefit.</div>
      )}
    </div>
  );
}
